import { Links } from '@/shared/constants/navegacao';
import { formatMonthParam } from '@/shared/utils/datas';

/** Rota da `PerMonthPage` (`/folhas`), com mês atual e `comFolha=true`. */
export function buildFolhasPorMesHref(referenceDate = new Date()): string {
  const mes = formatMonthParam(
    new Date(referenceDate.getFullYear(), referenceDate.getMonth(), 1),
  );
  return `${Links.Folhas_Por_Mes}?mes=${mes}&comFolha=true`;
}

/** Rota da `PerInternPage` — id `0` faz a tela escolher o primeiro estagiário. */
export function buildFolhasPorEstagiarioHref(estagiarioId = 0): string {
  const base = `${Links.Folhas_Por_Estagiario}/${estagiarioId}?page=1`;
  return estagiarioId > 0 ? `${base}&estagiarioId=${estagiarioId}` : base;
}
